/* eslint-disable react/prop-types */
import { useRef, useState } from "react";
import {
  Button,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  FormGroup,
  ModalFooter,
  Spinner,
} from "reactstrap";
import api from "../../../services/axiosConfig";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const ModalNF = ({
  isOpen,
  toggle,
  receiptNfPeriod,
  id,
}) => {
  const fileInputRef = useRef(null);
  const navigate = useNavigate();
  const [nomeArquivo, setNomeArquivo] = useState("");
  const [arquivo, setArquivo] = useState(null);
  const [loading, setLoading] = useState(false);
  const limiteValorNF = import.meta.env.VITE_VALOR_MINIMO_NF || 50;

  const date = (() => {
    if(receiptNfPeriod?.dataPagamento) {
      const mes = String(receiptNfPeriod?.dataPagamento?.split("/")[1]).padStart(
      2,
      "0"
    );
    const ano = receiptNfPeriod?.dataPagamento?.split("/")[2];
    return `${mes}/${ano}`;
    }

    if(receiptNfPeriod?.date) {
      const mes = String(receiptNfPeriod?.date?.split("/")[0]).padStart(
        2,
        "0"
      );
      const ano = receiptNfPeriod?.date?.split("/")[1];
      return `${mes}/${ano}`;
    }
  })();

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setNomeArquivo(file.name);
      setArquivo(file);
    }
  };

  const handleSubmit = async () => {
    setLoading(true);
    const todayDate = new Date()

    if(receiptNfPeriod?.values?.valorEmRealComDesconto > 50 && !arquivo){
      setLoading(false)
      await Swal.fire({
        title: "Atenção!",
        text: "Para valores acima de 50 reais, deve ser enviado uma NFS-e",
        icon: "error",
        confirmButtonText: "OK"
      });

      throw new Error("Erro ao emitir nota fiscal: Para valores acima de 50 reais, deve ser enviado uma NFS-e",);
    }

    try {
        const { data: nota } = await api.patch(`/nf/atualizar-nota/${id}`, {
          status: "emitida",
          dataEmissao: todayDate
        });

        if(arquivo){
          const formData = new FormData();
          formData.append("file", arquivo);

          await api.patch(`/nf/${nota._id}/upload`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });
        }
      
      const result = await Swal.fire({
        title: "Nota emitida",
        text: "Clique no botão abaixo para ver suas Notas Fiscais",
        icon: "success",
        confirmButtonText: "Ver Notas Fiscais!"
      });

      if (result.isConfirmed) {
        navigate("/minhas-notas-fiscais");
      }

      toggle();
    } catch (error) {
      console.error(error);
      toast.error("Erro ao enviar nota fiscal.");
      throw new Error("Erro ao enviar nota fiscal: ", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>
        <h1 className="titleFormNF">
          {receiptNfPeriod?.valorComDesconto > 50 || receiptNfPeriod?.values?.valorEmRealComDesconto > 50 ? "Envie sua Nota Fiscal" : 
          <>
            {
              receiptNfPeriod?.valorComDesconto < 0 || receiptNfPeriod?.values?.valorEmRealComDesconto < 0 ?
              "Minha Nota Fiscal" : "Solicitação de Pagamento"
            }
          </>
          }
        </h1>
      </ModalHeader>
      <ModalBody>
        {receiptNfPeriod?.valorComDesconto > limiteValorNF || receiptNfPeriod?.values?.valorEmRealComDesconto > limiteValorNF ? (
          <FormGroup>
          <Label>Referente ao mês de {date}</Label>
          <div style={{ marginTop: 10 }}>
            <Button color="light" onClick={handleClick} className="btnUpload">
              Escolher Arquivo PDF
            </Button>
            <input
              type="file"
              accept="application/pdf"
              ref={fileInputRef}
              onChange={handleFileChange}
              style={{ display: "none" }}
              required
            />
          </div>
          {nomeArquivo && (
            <p style={{ marginTop: "0.5rem", textAlign: "left" }}>
              <strong>{nomeArquivo}</strong>
            </p>
          )}
        </FormGroup>
        ) :(
          <FormGroup>
            <Label>Referente ao mês de {date}</Label>
            <div style={{ marginTop: 10 }}>
              {receiptNfPeriod?.valorComDesconto < 0 || receiptNfPeriod?.values?.valorEmRealComDesconto < 0 ? 
              <>
              <p>
                Sua Nota Fiscal não é necessária, pois o valor a receber é negativo.
              </p>
              <p>
                <b>Apenas salve a sua nota fiscal. Para ver suas Notas Fiscais salvas {" "}
                  <a href="/minhas-notas-fiscais">clique aqui!</a>
                </b>
              </p>
              </> 
              : 
                <>
                  <p>
                  Devido ao valor muito baixo, você não precisa enviar uma nota fiscal, apenas solicitar o pagamento.
                  </p>
                  <p>
                    <b>Após solicitar, aguarde o pagamento. Se deseja verificar o status do seu pagamento {""}
                      <a href="/minhas-notas-fiscais">clique aqui!</a>
                    </b>
                  </p>
                </>
            }
              
            </div>
          </FormGroup>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="success" onClick={handleSubmit} disabled={loading}>
          {loading ? <Spinner size="sm" /> : receiptNfPeriod?.valorComDesconto > 50 || receiptNfPeriod?.values?.valorEmRealComDesconto > 50 ? "Confirmar e enviar" :
          <>
            {
              receiptNfPeriod?.valorComDesconto < 0 || receiptNfPeriod?.values?.valorEmRealComDesconto < 0 ?
              "Salvar Nota Fiscal" : "Solicitar Pagamento"
            }
          </>
          
          }
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ModalNF;
